// John Eldhose 20180625
import { RestfulPost } from './Restful';

export async function getLanguage(language) {
  let data = {
    language: language
  };
  const Auth = await RestfulPost('getLanguage', data, (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return Auth;
}



// WEBPACK FOOTER //
// ./src/Api/getLanguage.js